import React, { useMemo } from "react";
import { Select, Tag } from "antd";

function normalizeCountriesData(countriesData) {
  if (!Array.isArray(countriesData)) return { countriesList: [], selectedCountries: [] };
  if (countriesData.every((entry) => typeof entry === "string")) {
    return { countriesList: countriesData, selectedCountries: countriesData };
  }
  const countriesList = [];
  const selectedCountries = [];
  countriesData.forEach((countryEntry) => {
    const countryCode = countryEntry && countryEntry.country != null ? countryEntry.country : "";
    if (!countryCode) return;
    countriesList.push(countryCode);
    if (!Object.prototype.hasOwnProperty.call(countryEntry, "selected") || countryEntry.selected) {
      selectedCountries.push(countryCode);
    }
  });
  return { countriesList, selectedCountries };
}

export default function MrlCountryList({
  countriesData = [],
  editMode = false,
  onChange,
}) {
  const { countriesList, selectedCountries } = useMemo(
    () => normalizeCountriesData(countriesData),
    [countriesData],
  );

  const handleSelectionChange = (values) => {
    if (onChange) {
      const updated = countriesList.map((countryCode) => ({
        country: countryCode,
        selected: values.includes(countryCode),
      }));
      onChange(updated);
    }
  };

  if (!editMode) {
    return (
      <div className="SpecManager_MrlCountryList">
        {selectedCountries.length > 0
          ? selectedCountries.map((countryCode) => (
            <Tag key={countryCode}>{countryCode}</Tag>
          ))
          : <span className="SpecManager_MrlPlaceholder">—</span>}
      </div>
    );
  }

  return (
    <Select
      mode="multiple"
      className="SpecManager_MrlSelect"
      placeholder="Please select countries"
      value={selectedCountries}
      options={countriesList.map((countryCode) => ({ value: countryCode, label: countryCode }))}
      onChange={handleSelectionChange}
    />
  );
}
